// Browser-side draft of a 360 provider's unsaved answers, so closing the tab or
// a failed save doesn't lose what they typed. Keyed per provider, receiver,
// team and block. Storage can be unavailable (private mode), so every access
// is guarded and failures are ignored.

const draftKey = ({ userId, userEvalId, groupId, blockId }) =>
  `k2g360draft:${userId}:${userEvalId}:${groupId || "-"}:${blockId}`;

export const loadAnswerDraft = (ids) => {
  try {
    const raw = window.localStorage.getItem(draftKey(ids));
    const parsed = raw ? JSON.parse(raw) : null;
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const saveAnswerDraft = (ids, answers) => {
  try {
    const typed = answers
      .filter((a) => (a?.answer || "").trim() !== "")
      .map((a) => ({ question: { _id: a.question._id }, id: a.question._id, answer: a.answer }));
    if (typed.length) window.localStorage.setItem(draftKey(ids), JSON.stringify(typed));
  } catch {
    // ignore
  }
};

export const clearAnswerDraft = (ids) => {
  try {
    window.localStorage.removeItem(draftKey(ids));
  } catch {
    // ignore
  }
};
